import { tv } from 'tailwind-variants';

export const CardWrapper = tv({
  base: 'relative w-full rounded-lg p-5 text-card-color-default shadow-level-1 cursor-pointer',
  variants: {
    color: {
      interdisciplinar:
        'bg-disciplina-interdisciplinar transition ease-in-out delay-100 text-card-color-default',
      redacao:
        'bg-disciplina-redacao transition ease-in-out delay-100 text-card-color-default',
      literatura:
        'bg-disciplina-literatura transition ease-in-out delay-100 text-card-color-default',
      espanhol:
        'bg-disciplina-espanhol transition ease-in-out delay-100 text-card-color-default',
      ingles:
        'bg-disciplina-ingles transition ease-in-out delay-100 text-card-color-default',
      portugues:
        'bg-disciplina-portugues transition ease-in-out delay-100 text-card-color-default',
      gramatica:
        'bg-disciplina-portugues transition ease-in-out delay-100 text-card-color-default',
      sociologia:
        'bg-disciplina-sociologia transition ease-in-out delay-100 text-card-color-default',
      filosofia:
        'bg-disciplina-filosofia transition ease-in-out delay-100 text-card-color-default',
      geografia:
        'bg-disciplina-geografia transition ease-in-out delay-100 text-card-color-default',
      historia:
        'bg-disciplina-historia transition ease-in-out delay-100 text-card-color-default',
      matematica:
        'bg-disciplina-matematica transition ease-in-out delay-100 text-card-color-default',
      fisica:
        'bg-disciplina-fisica transition ease-in-out delay-100 text-card-color-default',
      quimica:
        'bg-disciplina-quimica transition ease-in-out delay-100 text-card-color-default',
      biologia:
        'bg-disciplina-biologia transition ease-in-out delay-100 text-card-color-default',
      atualidades:
        'bg-disciplina-atualidades transition ease-in-out delay-100 text-card-color-default',
      'bioquimica-superior':
        'bg-disciplina-bioquimica-superior transition ease-in-out delay-100 text-card-color-default',
      'anatomia-superior':
        'bg-disciplina-anatomia-humana-superior transition ease-in-out delay-100 text-card-color-default',
      'histologia-humana-superior':
        'bg-disciplina-histologia-humana-superior transition ease-in-out delay-100 text-card-color-default',
      'fisiologia-superior':
        'bg-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 text-card-color-default',
      'genetica-superior':
        'bg-disciplina-genetica-superior transition ease-in-out delay-100 text-card-color-default',
      'embriologia-superior':
        'bg-disciplina-embriologia-superior transition ease-in-out delay-100 text-card-color-default',
      'imunologia-superior':
        'bg-disciplina-imunologia-superior transition ease-in-out delay-100 text-card-color-default',
      'microbiologia-superior':
        'bg-disciplina-microbiologia-superior transition ease-in-out delay-100 text-card-color-default',
      'parasitologia-superior':
        'bg-disciplina-parasitologia-superior transition ease-in-out delay-100 text-card-color-default',
      'patologia-superior':
        'bg-disciplina-patologia-superior transition ease-in-out delay-100 text-card-color-default',
      'farmacologia-superior':
        'bg-disciplina-farmacologia-superior transition ease-in-out delay-100 text-card-color-default',
      default: '',
    },
    selected: {
      true: 'bg-mono-color-medium !text-mono-color-dark',
    },
  },
});

export const IconPlus = tv({
  base: 'absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-circular transition-colors hover:bg-card-color-default hover:text-color-brand-primary',
  variants: {
    color: {
      interdisciplinar:
        'hover:text-disciplina-interdisciplinar transition ease-in-out delay-100 hover:bg-card-color-default',
      redacao:
        'hover:text-disciplina-redacao transition ease-in-out delay-100 hover:bg-card-color-default',
      literatura:
        'hover:text-disciplina-literatura transition ease-in-out delay-100 hover:bg-card-color-default',
      espanhol:
        'hover:text-disciplina-espanhol transition ease-in-out delay-100 hover:bg-card-color-default',
      ingles:
        'hover:text-disciplina-ingles transition ease-in-out delay-100 hover:bg-card-color-default',
      portugues:
        'hover:text-disciplina-portugues transition ease-in-out delay-100 hover:bg-card-color-default',
      gramatica:
        'hover:text-disciplina-portugues transition ease-in-out delay-100 hover:bg-card-color-default',
      sociologia:
        'hover:text-disciplina-sociologia transition ease-in-out delay-100 hover:bg-card-color-default',
      filosofia:
        'hover:text-disciplina-filosofia transition ease-in-out delay-100 hover:bg-card-color-default',
      geografia:
        'hover:text-disciplina-geografia transition ease-in-out delay-100 hover:bg-card-color-default',
      historia:
        'hover:text-disciplina-historia transition ease-in-out delay-100 hover:bg-card-color-default',
      matematica:
        'hover:text-disciplina-matematica transition ease-in-out delay-100 hover:bg-card-color-default',
      fisica:
        'hover:text-disciplina-fisica transition ease-in-out delay-100 hover:bg-card-color-default',
      quimica:
        'hover:text-disciplina-quimica transition ease-in-out delay-100 hover:bg-card-color-default',
      biologia:
        'hover:bg-card-color-default transition ease-in-out delay-100 hover:text-disciplina-biologia',
      atualidades:
        'hover:text-disciplina-atualidades transition ease-in-out delay-100 hover:bg-card-color-default',
      'bioquimica-superior':
        'hover:text-disciplina-bioquimica-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'anatomia-superior':
        'hover:text-disciplina-anatomia-humana-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'histologia-humana-superior':
        'hover:text-disciplina-histologia-humana-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'fisiologia-superior':
        'hover:text-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'genetica-superior':
        'hover:text-disciplina-genetica-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'embriologia-superior':
        'hover:text-disciplina-embriologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'imunologia-superior':
        'hover:text-disciplina-imunologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'microbiologia-superior':
        'hover:text-disciplina-microbiologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'parasitologia-superior':
        'hover:text-disciplina-parasitologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'patologia-superior':
        'hover:text-disciplina-patologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      'farmacologia-superior':
        'hover:text-disciplina-farmacologia-superior transition ease-in-out delay-100 hover:bg-card-color-default',
      default: '',
    },
    selected: {
      true: 'border-hairline border-brand-color-primary-pure',
    },
  },
});

export const IconRemove = tv({
  base: 'h-4 w-4 rounded-circular bg-card-color-default text-[16px]',
  variants: {
    color: {
      interdisciplinar:
        'text-disciplina-interdisciplinar transition ease-in-out delay-100 ',
      redacao: 'text-disciplina-redacao transition ease-in-out delay-100 ',
      literatura:
        'text-disciplina-literatura transition ease-in-out delay-100 ',
      espanhol: 'text-disciplina-espanhol transition ease-in-out delay-100 ',
      ingles: 'text-disciplina-ingles transition ease-in-out delay-100 ',
      portugues: 'text-disciplina-portugues transition ease-in-out delay-100 ',
      gramatica: 'text-disciplina-portugues transition ease-in-out delay-100 ',
      sociologia:
        'text-disciplina-sociologia transition ease-in-out delay-100 ',
      filosofia: 'text-disciplina-filosofia transition ease-in-out delay-100 ',
      geografia: 'text-disciplina-geografia transition ease-in-out delay-100 ',
      historia: 'text-disciplina-historia transition ease-in-out delay-100 ',
      matematica:
        'text-disciplina-matematica transition ease-in-out delay-100 ',
      fisica: 'text-disciplina-fisica transition ease-in-out delay-100 ',
      quimica: 'text-disciplina-quimica transition ease-in-out delay-100 ',
      biologia: ' transition ease-in-out delay-100 text-disciplina-biologia',
      atualidades:
        'text-disciplina-atualidades transition ease-in-out delay-100 ',
      'bioquimica-superior':
        'text-disciplina-bioquimica-superior transition ease-in-out delay-100 ',
      'anatomia-superior':
        'text-disciplina-anatomia-humana-superior transition ease-in-out delay-100 ',
      'histologia-humana-superior':
        'text-disciplina-histologia-humana-superior transition ease-in-out delay-100 ',
      'fisiologia-superior':
        'text-disciplina-fisiologia-humana-superior transition ease-in-out delay-100 ',
      'genetica-superior':
        'text-disciplina-genetica-superior transition ease-in-out delay-100 ',
      'embriologia-superior':
        'text-disciplina-embriologia-superior transition ease-in-out delay-100 ',
      'imunologia-superior':
        'text-disciplina-imunologia-superior transition ease-in-out delay-100 ',
      'microbiologia-superior':
        'text-disciplina-microbiologia-superior transition ease-in-out delay-100 ',
      'parasitologia-superior':
        'text-disciplina-parasitologia-superior transition ease-in-out delay-100 ',
      'patologia-superior':
        'text-disciplina-patologia-superior transition ease-in-out delay-100 ',
      'farmacologia-superior':
        'text-disciplina-farmacologia-superior transition ease-in-out delay-100 ',
      default: '',
    },
    selected: {
      true: 'border-hairline border-brand-color-primary-pure',
    },
  },
});
